var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "modal-dates-" + _vm.talentId,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "modal-date-applied-for",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            _vm._l(_vm.dates, function (date, index) {
              return _c(
                "button",
                {
                  key: index,
                  class: [
                    _vm.selectedDate === date
                      ? "btn-primary btn-lg"
                      : "btn-dark",
                    "btn btn-block",
                  ],
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setSelectedDate(date)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("date")(date, _vm.$user.date_format_preference)
                      ) +
                      "\n        "
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger btn-lg pull-left",
                attrs: { "data-dismiss": "modal" },
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg",
                attrs: { "data-dismiss": "modal" },
                on: { click: _vm.handleDateAppliedForCallback },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.bookingIsStandardPackage || !_vm.$declineModuleEnabled
                        ? "Accept"
                        : "Apply"
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title center" }, [
        _vm._v("Select Your Preferred Date"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }